'use client'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog'

type Props = {
	isOpen: boolean
	onConfirm?: () => void
	onDecline?: () => void
}

const DeleteConversationDialog = ({ isOpen, onConfirm, onDecline }: Props) => {
	return (
		<AlertDialog open={isOpen} onOpenChange={onDecline}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Delete Conversation?</AlertDialogTitle>
					<AlertDialogDescription>
						Are you sure you want to delete the conversation? This action will remove the conversation from
						all people in your company.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={onDecline}>Cancel</AlertDialogCancel>
					<AlertDialogAction className="bg-red-500 hover:bg-red-400" onClick={onConfirm}>
						Delete
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

export default DeleteConversationDialog
